import { render, staticRenderFns } from "./InstrumentLedger.vue?vue&type=template&id=4f420c56&scoped=true"
import script from "./InstrumentLedger.vue?vue&type=script&lang=js"
export * from "./InstrumentLedger.vue?vue&type=script&lang=js"
import style0 from "./InstrumentLedger.vue?vue&type=style&index=0&id=4f420c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f420c56",
  null
  
)

export default component.exports